export const navLinks = [
  { label: "How It Works", href: "#how-it-works" },
  { label: "Pricing",      href: "#pricing" },
  // { label: "How To Do",    href: "#how-to-do" },
];
